import { render, staticRenderFns } from "./CategoryCardProfitabilityMain.vue?vue&type=template&id=215ef09c&scoped=true"
import script from "./CategoryCardProfitabilityMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryCardProfitabilityMain.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryCardProfitabilityMain.vue?vue&type=style&index=0&id=215ef09c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ef09c",
  null
  
)

export default component.exports